import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Link, Typography, Avatar } from '@material-ui/core';
import FooterImage from './Icons/footer_logo.png';
import I18n from '../../config/locales';
import { getCountryBasedLink } from '../../utils/helper';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3, 0),
    marginTop: 'auto',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff'
  },
  withPaddingRoot: {
    padding: theme.spacing(3, 4)
  },
  columnDirection: {
    display: 'flex',
    flexDirection: 'column'
  },
  privacyTerms: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    '& > p': {
      paddingRight: theme.spacing(1)
    },
    flexWrap: 'wrap'
  },
  link: {
    color: `${theme.palette.tertiary.main} !important`,
    cursor: 'pointer !important',
    padding: `${theme.spacing(0, 1)} !important`
  },
  removePaddingPrivacy: {
    [theme.breakpoints.down('xs')]: {
      paddingLeft: `${theme.spacing(0)} !important`
    }
  },
  copyRights: {
    fontSize: '12px !important'
  },
  footerLogo: {
    height: theme.spacing(3.5),
    width: theme.spacing(15.5),
    minHeight: theme.spacing(3.5),
    marginRight: theme.spacing(2.5)
  },
  footerContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  privacyTermsWrapper: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(-1)
    },
    '& a:first-child': {
      paddingLeft: 0
    }
  }
}));

const FooterWithoutLanguageSwitchSG = (props = {}) => {
  const classes = useStyles();
  const { withPadding = false, className = '' } = props;
  const pathName = window.location.pathname;
  const splitPathName = pathName.split('/');
  const pathArray = [];
  splitPathName.forEach(path => path && pathArray.push(path));
  return (
    <footer className={clsx(classes.root, withPadding && classes.withPaddingRoot, className && className)}>
      <Box className={classes.footerContainer}>
        <Box>
          <Link title={I18n.t('footer.imageTitle')} href="http://enphase.com/" target="_blank">
            <Avatar variant="square" className={classes.footerLogo} alt="enphase footer logo" src={FooterImage} />
          </Link>
        </Box>
        <Box className={classes.columnDirection}>
          <Box className={classes.privacyTerms}>
            <Typography className={classes.copyRights}>
              {I18n.t('footer.enphaseText', { currentYear: moment().year() })}
            </Typography>
            <Box className={classes.privacyTermsWrapper}>
              <Link
                className={clsx(classes.link, classes.removePaddingPrivacy)}
                onClick={() => window.open(getCountryBasedLink('privacy'), '_blank')}
                target="_blank"
              >
                {I18n.t('footer.privacy')}
              </Link>
              <Typography>|</Typography>
              <Link
                className={classes.link}
                onClick={() => window.open(getCountryBasedLink('terms'), '_blank')}
                target="_blank"
              >
                {I18n.t('footer.terms')}
              </Link>
            </Box>
          </Box>
          { props.version && <Box className={classes.privacyTermsWrapper}>
            <Typography className={classes.copyRights}>
          v { props.version }
            </Typography>
          </Box> }
        </Box>
      </Box>
    </footer>
  );
};

FooterWithoutLanguageSwitchSG.propTypes = {
  locale: PropTypes.string,
  companyId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  currentlySending: PropTypes.bool,
  isQuotesExpanded: PropTypes.bool,
  getAccountData: PropTypes.func
};

export default FooterWithoutLanguageSwitchSG;
